import styled from "styled-components";
import {PjTa} from "../../Types";
import {schemas} from "../../config";
import {LANG} from "../CONSTANTS";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faListCheck} from "@fortawesome/free-solid-svg-icons";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {fetchTableByQuery, setSelectedTableFieldSet} from "../../features/tableSlice";


export default function AsideTableFieldSetSelector({tableName, projectName, selectedSet}: PjTa & {
    selectedSet?: string
}) {

    const set = schemas[projectName].tables[tableName].fieldSets;
    const tableStatus = useAppSelector(state => state.tables.tableInfo[tableName].loading)

    const dispatch = useAppDispatch();

    const changeSet = (newSet: string, changed: boolean) => {
        if (changed) {
            dispatch(setSelectedTableFieldSet({table: tableName, set: newSet}))
            dispatch(fetchTableByQuery({clean: true, pageIndex: 1}))
        }
    };

    if (!set || set.order.length < 2)
        return null

    return <Container>
        <ul className="sets">
            {set.order.map((key, i) => (
                <li className="set" key={i}>
                    <Button disabled={tableStatus !== 'idle'} className="btn-cmn set-btn"
                            $isSelected={key === selectedSet}
                            onClick={() => changeSet(key, key !== selectedSet)}>
                        {set.sets[key]
                            ? (set.sets[key].shortName?.[LANG] || set.sets[key].name[LANG])
                            : key === 'all' ? 'Всі' : "Невідомо"}
                    </Button>
                </li>
            ))}
        </ul>
        <div className={'manage'}>
            <FontAwesomeIcon icon={faListCheck} style={{width: '1rem', height: "1rem"}} className={'fa-color-text'}/>
        </div>
    </Container>
}

const Button = styled.button<{ $isSelected?: boolean }>`
    background: ${props => props.$isSelected ? 'var(--table-action-color)' : 'var(--table-row-odd-bg-color)'};
    color: ${props => !props.$isSelected ? 'var(--table-row-text-color)' : 'var(--secondary-text)'};
`

const Container = styled.div`
    width: 100%;
    display: flex;
    justify-content: center; /* centers content when there's no overflow */
    overflow: hidden; /* hides nothing important */
    gap: .5rem;

    .manage {
        display: flex;
        //flex-grow: 0;
        //flex-shrink: 0;
        justify-content: center;
        align-items: center;
        //margin-left: auto;
    }

    .sets {
        display: inline-flex; /* keeps content in one line */
        width: 100%;
        //justify-content: center;
        //flex-grow: 0;
        //flex-shrink: 0;
        flex-wrap: nowrap;
        gap: .5rem;
        white-space: nowrap;
        padding-bottom: .25rem;
        overflow-x: auto; /* scroll only inside the UL */
        overflow-y: hidden;
        max-width: 100%; /* prevents pushing outside */
        text-align: center; /* center when short */
        scroll-behavior: smooth;
    }

    .set {
        list-style: none;
        //flex: 0 0 auto;         /* prevents shrinking */

        &:last-child {
            margin-right: auto;
        }

        &:first-child {
            margin-left: auto;
        }

        & .set-btn {
            font-size: .85rem;

        }
    }
`;
